// frontend/src/common/ui/Portal/Portal.tsx
import { createPortal } from 'react-dom'
import { useLayoutEffect, useState } from 'react'
import { cn } from '@/common/lib/cn/cn'
import './portal.css'

export type PortalProps = {
    children: React.ReactNode
    container?: string | HTMLElement
    className?: string
}

export const Portal = ({ children, container = 'body', className }: PortalProps) => {
    const [mountNode, setMountNode] = useState<HTMLElement | null>(null)

    useLayoutEffect(() => {
        let targetElement: HTMLElement | null = null

        if (typeof container === 'string') {
            targetElement = document.querySelector(container)
        } else {
            targetElement = container
        }

        if (!targetElement) {
            targetElement = document.body
        }

        const portalContainer = document.createElement('div')
        portalContainer.className = cn('portal-mount-root', className)

        targetElement.appendChild(portalContainer)
        setMountNode(portalContainer)

        return () => {
            if (portalContainer.parentNode === targetElement) {
                targetElement.removeChild(portalContainer)
            }
        }
    }, [container, className])

    return mountNode ? createPortal(children, mountNode) : null
}
